export default __webpack_public_path__ + "static/media/gallery_08.eb34a609.jpg";